export default {
    SET_LOADING_STATE: "profile/SET_LOADING_STATE",
    SET_PROFILE_DATA: "profile/SET_PROFILE_DATA",
};
